import PickupDelivery from 'src/components/PickupDelivery/PickupDelivery';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { AppointmentActionCreator, FrameworkActionCreator} from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    locale: state.Framework.locale,
    name: state.Appointment.ApptCust.custFirstName,
    nameID: state.Appointment.ApptCust.custNameId,
    pudoAddComments: state.Appointment.ApptLocCom.pudoAddComments,
    puAddress: state.Appointment.ApptPULoc.puAddress,
    puZipPostal: state.Appointment.ApptPULoc.puZipPostal,
    puCity: state.Appointment.ApptPULoc.puCity,
    puStateProvince: state.Appointment.ApptPULoc.puStateProvince,
    doAddress: state.Appointment.ApptDOLoc.doAddress,
    doZipPostal: state.Appointment.ApptDOLoc.doZipPostal,
    doCity: state.Appointment.ApptDOLoc.doCity,
    doStateProvince: state.Appointment.ApptDOLoc.doStateProvince,
    zipReturn: state.Appointment.ZIPSearchReturn,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    theme: state.Framework.theme,
    countryCode: state.Framework.dealerCountry,
});

const mapDispatchToProps = {
    updatePickupInfo: AppointmentActionCreator.updatePickupFields,
    updateDropoffInfo: AppointmentActionCreator.updateDeliveryFields,
    updateAddCom: AppointmentActionCreator.updateLocationComments,
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    zipSearch: AppointmentActionCreator.ZIPSearch,
    clearZipSearch: AppointmentActionCreator.clearZIPSearch,
};

export default connect (mapStateToProps, mapDispatchToProps)(PickupDelivery);